__webpack_require__.p = "/kredittbank-kredittbanken-web/";